import React, { useState, useEffect, useRef } from 'react'

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import Switch from '@material-ui/core/Switch';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { DataGrid, GridOverlay, useGridApiContext, useGridSelector, gridPageCountSelector, gridPageSelector, gridPageSizeSelector } from '@mui/x-data-grid'
import Pagination from '@material-ui/lab/Pagination'
import ListAlt from '@material-ui/icons/ListAlt';
import Menu from '@material-ui/icons/Menu';
import Description from '@material-ui/icons/Description';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Refresh from '@material-ui/icons/Refresh';
import GetApp from '@material-ui/icons/GetApp';
import Build from '@material-ui/icons/Build';
import Search from '@material-ui/icons/Search';
import Close from '@material-ui/icons/Close';
import PlaylistAddCheck from '@material-ui/icons/PlaylistAddCheck';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PopoverMenu from '@material-ui/core/Menu';
import SelectSDocGroupTypeModal from 'components/sdoc-admin/manage/select-set-sdoc-grouptype-modal'
import { useHistory } from 'react-router-dom'
import { useStoreRehydrated, useStoreState } from '@store'

import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { format } from 'date-fns'

import { sdoc, sdocAdmin, admin } from '@api'
import Swal from 'sweetalert2/dist/sweetalert2.js'

function CustomPagination() {
	const apiRef = useGridApiContext()
	const page = useGridSelector(apiRef, gridPageSelector)
	const pageSize = useGridSelector(apiRef, gridPageSizeSelector)
	const pageCount = useGridSelector(apiRef, gridPageCountSelector)

	return (
		<Grid className="flex flex-row items-center w-full justify-between px-2">
			<Grid className="flex flex-row items-center">
				<Typography variant="body2" className="mr-2">Rows per page:</Typography>
				<Select
					value={pageSize}
					onChange={(e) => apiRef.current.setPageSize(Number(e.target.value))}
					disableUnderline
				>
					{[5, 10, 25, 50].map((size) => (
						<MenuItem key={size} value={size}>
							{size}
						</MenuItem>
					))}
				</Select>
			</Grid>
			<Pagination
				className="p-2"
				color="primary"
				count={pageCount}
				page={page + 1}
				onChange={(event, value) => apiRef.current.setPage(value - 1)}
				showFirstButton
				showLastButton
			/>
		</Grid>
	);
}


const RowActions = ({ params, myRole, adminProfile, history, confirmRepairCredential, onClickSetSDocGroupType, handleRevoke }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const RoleID = myRole;

	return (
		<Grid className="flex flex-row justify-start items-center gap-x-2">
			<Button
				className={`w-24`}
				color="primary"
				variant="contained"
				onClick={() => {
					history.push(
						`/admin/sdoc/sent/${params.row.id}?mountType=readOnly`
					)
				}}>
				<Menu style={{ fontSize: 16 }} className="mr-1" />
				<Grid className={`text-xs`}>รายละเอียด</Grid>
			</Button>

			<a
				href={`${process.env.REACT_APP_PUBLIC_API_URL}/api/Document/sDocPaper/${params.row.id}`}
				target="_blank"
				rel="noreferrer">
				<Button className={`w-40`} color="primary" variant="contained">
					<GetApp style={{ fontSize: 16 }} className="mr-1" />
					<Grid className={`text-xs`}>ดาวน์โหลดหนังสือรับรอง</Grid>
				</Button>
			</a>
			{RoleID !== 16 && RoleID !== 18 && (
				<a
					href={`${process.env.REACT_APP_PUBLIC_API_URL}/api/SDoc/${params.row.id}/AdminGetInvoice`}
					target="_blank"
					rel="noreferrer">
					<Button className={`w-40`} color="primary" variant="contained">
						<Description style={{ fontSize: 16 }} className="mr-1" />
						<Grid className={`text-xs`}>ดาวน์โหลดใบเสร็จรับเงิน</Grid>
					</Button>
				</a>
			)}

			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				onClick={handleClick}
			>
				<MoreVertIcon />
			</IconButton>
			<PopoverMenu
				id="long-menu"
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={handleClose}
				PaperProps={{
					style: {
						width: '30ch',
					},
				}}
			>
				{RoleID !== 16 && RoleID !== 18 && (
					[
						<MenuItem key="repair" onClick={() => { confirmRepairCredential(params.row.id); handleClose(); }}>
							<Build style={{ fontSize: 16 }} className="mr-2" />
							ซ่อมแซมหนังสือรับรอง
						</MenuItem>,
						<MenuItem key="setGroup" onClick={() => { onClickSetSDocGroupType(params.row.id, params.row.sDocGroupType?.id); handleClose(); }}>
							<PlaylistAddCheck style={{ fontSize: 16 }} className="mr-2" />
							กำหนดกลุ่มประเภทเครื่องฯ
						</MenuItem>
					]
				)}
				{adminProfile?.id === 17 && RoleID !== 18 && (
					<MenuItem key="revoke" onClick={() => { handleRevoke(params.row.id); handleClose(); }}>
						<Close style={{ fontSize: 16 }} className="mr-2" />
						เพิกถอนหนังสือรับรอง
					</MenuItem>
				)}
			</PopoverMenu>
		</Grid>
	)
}

// Page Description: สถานะการยื่นแบบหนังสือรับรองตนเอง
export default function SDOCSent() {
	const isRehydrated = useStoreRehydrated()
	const history = useHistory()
	const [rowsApproveStatus, setRowsApproveStatus] = useState([])
	const [pageSize, setPageSize] = useState(10)
	const [currentPage, setCurrentPage] = useState(0)
	const [totalRows, setTotalRows] = useState(0)
	const [activeFilters, setActiveFilters] = useState({})
	const [isDataLoading, setIsDataLoading] = useState(true)
	const [myRole, setMyRole] = useState(null)
	const adminProfile = useStoreState(s => s.sdocAdminModel.adminMESDOC)

	const handleRevoke = (id) => {
		Swal.fire({
			title: 'เพิกถอนเอกสาร',
			input: 'text',
			inputLabel: 'ระบุเหตุผลการเพิกถอน',
			showCancelButton: true,
			confirmButtonText: 'ยืนยัน',
			cancelButtonText: 'ยกเลิก',
			inputValidator: (value) => {
				if (!value) {
					return 'กรุณาระบุเหตุผล'
				}
			}
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					const res = await sdocAdmin.revokeCredential(id, result.value)
					if (res && res.status === 200) {
						Swal.fire('สำเร็จ', 'เพิกถอนเอกสารสำเร็จ', 'success')
							.then(() => {
								refreshCurrentPage()
							})
					} else {
						Swal.fire('เกิดข้อผิดพลาด', res?.response?.data?.message || 'ไม่สามารถเพิกถอนเอกสารได้', 'error')
					}
				} catch (error) {
					console.error(error)
					Swal.fire('เกิดข้อผิดพลาด', 'ไม่สามารถเพิกถอนเอกสารได้', 'error')
				}
			}
		})
	}
	// eslint-disable-next-line

	const [activeSort, setActiveSort] = useState({ field: 'approveDate', sort: 'desc' })
	const [sortModel, setSortModel] = useState([
		{
			field: 'approveDate',
			sort: 'desc',
		},
	]);
	// Native DataGrid column-filter -> API params (merged into every fetch)
	const gridFilterParamsRef = useRef({})
	const gridFilterTimerRef = useRef(null)
	const [gridFilterModel, setGridFilterModel] = useState({ items: [] })
	// filter Dialog / Modal
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const [searchQuery, setSearchQuery] = useState([]);
	const [selectedStatus, setSelectedStatus] = useState([]);
	const [searchCreate, setSearchCreate] = useState('');
	const [searchLastUpdated, setSearchLastUpdated] = useState('');
	const [isSearching, setIsSearching] = useState(false);
	const [isSaveSearch, setIsSaveSearch] = useState(true);

	const statusOptions = [
		// { value: '0', label: 'ทั้งหมด' },
		{ value: '1', label: 'รอมอบหมาย' },
		{ value: '2', label: 'รอตรวจสอบ/เพิ่มเอกสารแล้ว/ปรับปรุงข้อมูลแล้ว' },
		{ value: '3', label: 'ขอเอกสารเพิ่ม/ขอปรับปรุงเอกสาร' },
		{ value: '4', label: 'รอออกใบรับรอง' },
		{ value: '5', label: 'อนุมัติ' },
		{ value: '6', label: 'ไม่อนุมัติ' },
		{ value: '8', label: 'รอชำระเงิน' },
		{ value: '82', label: 'เลยกำหนดชำระ' },
		{ value: '9', label: 'รอออกใบเสร็จรับเงิน' },
		{ value: '10', label: 'ยกเลิกคำขอ' },
		{ value: '11', label: 'เลยระยะเวลา' },
	];
	const toggleDialog = () => {
		setIsDialogOpen(!isDialogOpen);
	};
	const handleSearchChange = (event) => {
		const { id, value } = event.target;
		setSearchQuery((prevSearchQuery) => {
			const updatedQuery = [...prevSearchQuery];
			const existingItemIndex = updatedQuery.findIndex((item) => item.id === id);
			if (existingItemIndex !== -1) {
				updatedQuery[existingItemIndex] = { id, value };
			} else {
				updatedQuery.push({ id, value });
			}
			return updatedQuery;
		});
		// console.log(searchQuery);
	};

	const handleStatusChange = (event) => {
		setSelectedStatus(event.target.value);
	};
	const handleCreateChange = (event) => {
		setSearchCreate(event.target.value);
	};
	const handleLastUpdatedChange = (event) => {
		setSearchLastUpdated(event.target.value);
	};
	const handleSaveSearch = () => {
		setIsSaveSearch(!isSaveSearch);
	};
	// SDoCGroupType 
	const [sDocID, setSDocID] = useState(null)
	const [sDocGroupTypeID, setSDocGroupTypeID] = useState(null)
	const [sDocGroupTypeList, setSDocGroupTypeList] = useState([])
	const [openModalSelectSDocGroupType, setOpenModalSelectSDocGroupType] = useState(false)

	const onSetSDocGroupType = async () => {
		const res = await sdocAdmin.setSDocGroupType(sDocID, sDocGroupTypeID)
		if (res && res.status === 200) {
			refreshCurrentPage()
			setOpenModalSelectSDocGroupType(false);
			Swal.fire({
				title: 'กำหนดกลุ่มประเภทเครื่องโทรคมนาคมสำเร็จ',
				text: '',
				icon: 'success',
				confirmButtonText: 'ปิด'
			})
		}
	}

	const onChangeSDocGroupTypeID = event => {
		setSDocGroupTypeID(event.target.value)
	}

	const onClickSetSDocGroupType = (sDocID, SDocGroupTypeID) => {
		setSDocID(sDocID)
		setSDocGroupTypeID(SDocGroupTypeID)
		setOpenModalSelectSDocGroupType(true)
	}


	var columnsApproveStatus = [
		{
			field: 'sDocNoExport',
			headerName: 'sDoc No.',
			width: 180,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			filterable: false,
			editable: false,
			hide: true,
			valueGetter: (value, row) => {
				return row.sDocNo;
			}
		},
		{
			field: 'sDocNo',
			headerName: 'sDoc No.',
			width: 180,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
			renderCell: params => {
				return params.row.sDocNo;
			},
			valueGetter: (value, row) => {
				if (row.sDocNo) {
					return row.sDocNo.slice(8, 10) + '-' + row.sDocNo.slice(2, 7)
				}
			}
		},
		{
			field: 'runningNumber', // ERROR MARK
			headerName: 'เลขที่คำขอ',
			width: 180,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
		},
		{
			field: 'brandName',
			headerName: 'ตราอักษร (Brand Name)',
			width: 220,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
		},
		{
			field: 'productModel',
			headerName: 'รุ่นของผลิตภัณฑ์',
			width: 180,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
		},
		{
			field: 'sDocGroupType',
			headerName: 'กลุ่มประเภทเครื่องโทรคมนาคม',
			width: 300,
			headerAlign: 'center',
			align: 'center',
			sortable: true,
			filterable: false,
			editable: false,
			hide: false,
			renderCell: (params) => (
				<Grid style={{ lineHeight: "normal", whiteSpace: "normal" }}>
					{params.row.sDocGroupType ?? ''}
				</Grid>
			),
		},
		{
			field: 'operator',
			headerName: 'ผู้ยื่นเอกสาร',
			width: 200,
			headerAlign: 'left',
			align: 'center',
			sortable: true,
			editable: false,
			renderCell: (params) => (
				<Grid style={{ lineHeight: "normal", whiteSpace: "normal" }}>
					{/* {params.row.operator}<br />{params.row.operatorInfo && ('แทน ' + params.row.operatorInfo)} */}
					{params.row.operator}
				</Grid>
			),
			// valueGetter: (params) => {
			// 	if (params.row.operatorInfo) {
			// 		return params.value + ' แทน ' + params.row.operatorInfo + ')'
			// 	}
			// },
		},
		{
			field: 'operatorInfo',
			headerName: 'ยื่นในนาม',
			width: 200,
			headerAlign: 'left',
			align: 'center',
			sortable: true,
			editable: false,
			renderCell: (params) => (
				<Grid style={{ lineHeight: "normal", whiteSpace: "normal" }}>
					{params.row.operatorInfo && (params.row.operatorInfo)}
				</Grid>
			),
		},
		{
			field: 'approver',
			headerName: 'ผู้ได้รับมอบหมายงาน',
			width: 220,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
		},
		{
			field: 'signatureAdmin',
			headerName: 'ผู้ลงนาม',
			width: 220,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			filterable: false,
			editable: false,
		},
		{
			field: 'approveDateExport',
			headerName: 'วันที่ได้รับอนุมัติ',
			width: 170,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			filterable: false,
			editable: false,
			hide: true,
			renderCell: params => (
				<Grid className="">
					{params.value ? format(new Date(params.row.approveDateExport), 'MM/dd/yyyy HH:mm') : ''}
					{/* {params.value ? params.value : ''} */}
				</Grid>
			),
			valueGetter: (value, row) => {
				if (row.approveDateExport) {
					return format(new Date(value), 'MM/dd/yyyy HH:mm')
				}
			}
		},
		{
			field: 'invoiceDate',
			headerName: 'วันที่ได้รับใบเสร็จรับเงิน',
			width: 170,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			filterable: false,
			editable: false,
			hide: true,
			renderCell: params => (
				<Grid className="">
					{params.value ? format(new Date(params.row.invoiceDate), 'MM/dd/yyyy HH:mm') : ''}
					{/* {params.value ? params.value : ''} */}
				</Grid>
			),
			valueGetter: (value, row) => {
				if (row.approveDateExport) {
					return format(new Date(value), 'MM/dd/yyyy HH:mm')
				}
			}
		},
		{
			field: 'approveDate',
			headerName: 'วันที่ได้รับอนุมัติ',
			width: 170,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			filterable: false,
			editable: false,
			renderCell: params => (
				<Grid className="">
					{/* {params.value ? format(new Date(params.value), 'dd/MM/yyyy HH:mm') : ''} */}
					{params.value ? params.value : ''}
				</Grid>
			),
			valueGetter: (value, row) => {
				if (row.approveDate) {
					return format(new Date(value), 'dd/MM/yyyy HH:mm')
				}
			}
		},
		{
			field: 'amount',
			headerName: 'เงินที่ได้รับ',
			width: 170,
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			filterable: false,
			editable: false,
			hide: true,
			renderCell: params => (
				<Grid className="">
					{params.value ? params.value.toFixed(2) + " บาท" : ''}
				</Grid>
			),
		},
		{
			field: 'activity',
			headerName: 'กิจกรรม',
			width: 500,
			headerAlign: 'left',
			align: 'left',
			sortable: false,
			filterable: false,
			editable: false,
			renderCell: params => {
				return (
					<RowActions
						params={params}
						myRole={myRole}
						adminProfile={adminProfile}
						history={history}
						confirmRepairCredential={confirmRepairCredential}
						onClickSetSDocGroupType={onClickSetSDocGroupType}
						handleRevoke={handleRevoke}
					/>
				)
			},
		},
	]
	const lastSortKeyRef = useRef('approveDate|desc');
	const sortTimerRef = useRef(null);
	const handleSortChange = (model) => {
		if (sortTimerRef.current) clearTimeout(sortTimerRef.current);
		sortTimerRef.current = setTimeout(() => {
			const sort = model[0] || { field: '', sort: '' };
			const key = `${sort.field}|${sort.sort}`;
			if (key === lastSortKeyRef.current) return;
			lastSortKeyRef.current = key;
			setSortModel(model);
			setActiveSort(sort);
			setCurrentPage(0);
			if (isRehydrated) {
				getSDOCWaitStatusList(0, activeFilters, pageSize, sort);
			}
		}, 0);
	};
	const createApproveRow = (dataSDocList, i) => {
		const rowData = {
			id: dataSDocList[i].id,
			brandName: dataSDocList[i].brandName,
			operator:
				(dataSDocList[i].sDocUser.prefix ?? '') +
				dataSDocList[i].sDocUser.firstname +
				' ' +
				dataSDocList[i].sDocUser.lastname,
			approver: dataSDocList[i].approver
				?
				(dataSDocList[i].approver.prefixname ?? '') +
				dataSDocList[i].approver.firstname +
				' ' +
				dataSDocList[i].approver.lastname
				: 'ยังไม่ได้มอบหมาย',
			approveDate: dataSDocList[i].approveDate,
			approveDateExport: dataSDocList[i].approveDate,
			invoiceDate: dataSDocList[i].sDocTransactions?.receiveDate,
			signatureAdmin: dataSDocList[i].signatureAdmin
				?
				(dataSDocList[i].signatureAdmin.prefixname ?? '') +
				dataSDocList[i].signatureAdmin.firstname +
				' ' +
				dataSDocList[i].signatureAdmin.lastname
				: 'ยังไม่ได้ลงนาม',
			statusID: dataSDocList[i].sDocStatusID,
			statusName: dataSDocList[i].sDocStatus.statusName,
			productModel: dataSDocList[i].productModel,
			sDocNo: dataSDocList[i].sDocNo,
			operatorInfo: dataSDocList[i].senderType === 'organization' ? dataSDocList[i].operatorTitle : null,
			runningNumber: dataSDocList[i].runningNo, // ERROR MARK
			amount: dataSDocList[i].sDocTransactions.amount * 1.07,
			sDocGroupType: dataSDocList[i].sDocGroupType?.groupName ?? '',
		}
		return rowData
	}

	const getSDocStatusList = async () => {
		// Get Status List
		const resStatusList = await sdoc.getListsStatus()
		const dataStatusList = resStatusList.data
		const statusListTemp = []
		if (resStatusList) {
			if (resStatusList.status === 200) {
				for (let i = 0; i < dataStatusList.length; i++) {
					statusListTemp.push({
						id: dataStatusList[i].id,
						statusName: dataStatusList[i].statusName,
					})
				}
			}
		}
		return statusListTemp
	}

	const getCheckerAdminList = async () => {
		const resAdminList = await sdocAdmin.getAdminList()
		const adminListTemp = []
		if (resAdminList) {
			if (resAdminList.status === 200) {
				const dataAdminList = resAdminList.data
				for (let i = 0; i < dataAdminList.length; i++) {
					if (dataAdminList[i].adminRoleID === 4) {
						adminListTemp.push({
							id: dataAdminList[i].id,
							name:
								dataAdminList[i].firstname + ' ' + dataAdminList[i].lastname,
						})
					}
				}
			}
		}
	}

	const handleExportCSV = async (mode = 'table') => {
		handleCloseDialogExportCSV()
		Swal.fire({ title: 'กำลังโหลดข้อมูล...', allowOutsideClick: false, didOpen: () => { Swal.showLoading() } })
		const exportParams = mode === 'range'
			? { approveStartDate: startDate, approveEndDate: endDate, exportAll: true }
			: { ...activeFilters, ...gridFilterParamsRef.current, exportAll: true }
		const resList = await sdoc.getListsApproved(exportParams)
		Swal.close()
		if (resList && resList.status === 200) {
			let { data } = resList.data
			// For range mode, filter client-side by approve date so the result is
			// correct even if the backend approveStartDate/approveEndDate filter is
			// not yet deployed.
			if (mode === 'range') {
				data = data.filter(d => {
					if (!d.approveDate) return false
					const approve = d.approveDate.slice(0, 10) // YYYY-MM-DD
					return (!startDate || approve >= startDate) && (!endDate || approve <= endDate)
				})
			}
			const fields = ['signatureAdmin', 'approveDateExport', 'invoiceDate', 'sDocNo', 'operator', 'operatorInfo', 'brandName', 'productModel', 'sDocGroupType', 'approver', 'amount']
			const headers = ['ผู้ลงนาม', 'วันที่ได้รับอนุมัติ', 'วันที่ได้รับใบเสร็จรับเงิน', 'sDoc No.', 'ผู้ยื่นเอกสาร', 'ยื่นในนาม', 'ตราอักษร (Brand Name)', 'รุ่นของผลิตภัณฑ์', 'กลุ่มประเภทเครื่องโทรคมนาคม', 'ผู้ได้รับมอบหมายงาน', 'เงินที่ได้รับ']
			const rows = data.map((_, i) => createApproveRow(data, i))
			const header = headers.join(',')
			const csvRows = rows.map(row => fields.map(f => `"${row[f] ?? ''}"`).join(','))
			const blob = new Blob(['\uFEFF' + [header, ...csvRows].join('\n')], { type: 'text/csv;charset=utf-8;' })
			const link = document.createElement('a')
			link.href = URL.createObjectURL(blob)
			link.download = 'รายการใบคำขอที่ได้รับอนุมัติ.csv'
			link.click()
			URL.revokeObjectURL(link.href)
		}
	}

	const forceSDOCWaitStatusList = () => {
		setCurrentPage(0)
		getSDOCWaitStatusList(0, activeFilters)
	}

	const getSDOCWaitStatusList = async (page = 0, filters = {}, size = pageSize, sort = activeSort) => {
		setIsDataLoading(true)
		setRowsApproveStatus([])
		getSDocStatusList()

		await admin.me().then(async event => {
			if (event) {
				const dataMe = event.data
				setMyRole(dataMe.roleID)

				const resList = await sdoc.getListsApproved({ page: page + 1, pageSize: size, ...filters, ...gridFilterParamsRef.current, ...(sort?.field ? { sortField: sort.field, sortOrder: sort.sort } : {}) })
				if (resList && resList.status === 200) {
					const { data: dataSDocList, total } = resList.data
					const rowsApproveTemp = dataSDocList.map((_, i) => createApproveRow(dataSDocList, i))
					setRowsApproveStatus(rowsApproveTemp)
					setTotalRows(total)
				}
			}
		})
		setIsDataLoading(false)
		getCheckerAdminList()
	}
	const refreshCurrentPage = () => {
		getSDOCWaitStatusList(currentPage, activeFilters)
	}

	const buildFilterParams = () => {
		const fieldMap = { sDocNo: 'sDocNo', runningNumber: 'runningNo', brandName: 'brandName', productModel: 'productModel', operator: 'operatorName', operatorInfo: 'operatorInfo', approver: 'approver', refNo1: 'refNo1', refNo2: 'refNo2', invoiceNo: 'invoiceNo' };
		const filters = {};
		searchQuery.forEach(({ id, value }) => { if (value && value.length > 0 && fieldMap[id]) filters[fieldMap[id]] = value; });
		if (searchCreate) filters.submitDate = searchCreate;
		if (searchLastUpdated) filters.lastUpdate = searchLastUpdated;
		return filters;
	};

	// filter
	const onSearchResult = () => {
		if (isSaveSearch) {
			localStorage.setItem('savedFiltersApproved', JSON.stringify({ searchQuery, searchCreate, searchLastUpdated, selectedStatus }));
		} else {
			localStorage.removeItem('savedFiltersApproved');
		}
		const filters = buildFilterParams();
		setActiveFilters(filters);
		setCurrentPage(0);
		setIsDialogOpen(false);
		setIsSearching(true);
		getSDOCWaitStatusList(0, filters);
	};

	const applySavedFilters = () => {
		const saved = localStorage.getItem('savedFiltersApproved');
		if (saved) {
			const { searchQuery: sq, searchCreate: sc, searchLastUpdated: sl, selectedStatus: ss } = JSON.parse(saved);
			setSearchQuery(sq);
			setSearchCreate(sc || '');
			setSearchLastUpdated(sl || '');
			setSelectedStatus(ss);
			setIsSearching(true);
			setIsSaveSearch(true);
			const fieldMap = { sDocNo: 'sDocNo', runningNumber: 'runningNo', brandName: 'brandName', productModel: 'productModel', operator: 'operatorName', operatorInfo: 'operatorInfo', approver: 'approver', refNo1: 'refNo1', refNo2: 'refNo2', invoiceNo: 'invoiceNo' };
			const filters = {};
			sq.forEach(({ id, value }) => { if (value && value.length > 0 && fieldMap[id]) filters[fieldMap[id]] = value; });
			if (sc) filters.submitDate = sc;
			if (sl) filters.lastUpdate = sl;
			setActiveFilters(filters);
			return filters;
		}
		return {};
	};

	const onSearchResultClear = () => {
		setSearchQuery([]);
		setSearchCreate('');
		setSearchLastUpdated('');
		setSelectedStatus([]);
		setIsSearching(false);
		setIsSaveSearch(false);
		setActiveFilters({});
		setCurrentPage(0);
		localStorage.removeItem('savedFiltersApproved');
		getSDOCWaitStatusList(0, {});
	};

	// repairCredential
	const confirmRepairCredential = async (sDocID) => {
		const shouldRepair = await Swal.fire({
			title: 'คุณต้องการที่จะดำเนินการซ่อมแซมหนังสือรับรองนี้หรือไม่?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'ใช่',
			cancelButtonText: 'ไม่',
		});

		if (shouldRepair.isConfirmed) {
			onRepairCredential(sDocID);
		}
	};

	// Call confirmRepairCredential when you want to initiate the repair

	const onRepairCredential = async sDocID => {
		const res = await sdocAdmin.repairCredential(sDocID)
		if (res && res.status === 200 && res.data.status == "success") {
			refreshCurrentPage()
			Swal.fire({
				title: 'ซ่อมแซมหนังสือรับรองสำเร็จ',
				text: 'ซ่อมแซมหนังสือรับรองสำเร็จ',
				icon: 'success',
				confirmButtonText: 'ปิด'
			})
		} else if (res && res.status === 200 && res.data.status == "fail") {
			Swal.fire({
				title: 'ซ่อมแซมหนังสือรับรองไม่สำเร็จ',
				text: res.data.message,
				icon: 'error',
				confirmButtonText: 'ปิด'
			})
		}
	}

	// Native DataGrid column filter -> server params (same field map as the filter dialog)
	const gridFieldToApi = {
		sDocNo: 'sDocNo',
		runningNumber: 'runningNo',
		brandName: 'brandName',
		productModel: 'productModel',
		operator: 'operatorName',
		operatorInfo: 'operatorInfo',
		approver: 'approver',
	};
	const handleFilterChange = (model) => {
		setGridFilterModel(model);
		if (gridFilterTimerRef.current) clearTimeout(gridFilterTimerRef.current);
		gridFilterTimerRef.current = setTimeout(() => {
			const params = {};
			(model.items || []).forEach(({ field, value }) => {
				const key = gridFieldToApi[field];
				if (!key || value === undefined || value === null || value === '') return;
				params[key] = value;
			});
			gridFilterParamsRef.current = params;
			setCurrentPage(0);
			getSDOCWaitStatusList(0, activeFilters);
		}, 500);
	};
	useEffect(() => {
		if (isRehydrated) {
			const savedFilters = applySavedFilters()
			getSDOCWaitStatusList(0, savedFilters)
		}
		if (sDocGroupTypeList.length === 0) {
			sdocAdmin.getSDocGroupType().then(res => {
				if (res && res.status === 200) {
					setSDocGroupTypeList(res.data)
				}
			})
		}
		// eslint-disable-next-line
	}, [isRehydrated])
	const handleDownloadClick = async () => {
		try {
			handleCloseDialogRangeDate();
			// Display a loading popup
			const loadingPopup = Swal.fire({
				title: 'กำลังดาวน์โหลดไฟล์',
				text: 'โปรดรอสักครู่...',
				icon: 'info',
				showCancelButton: false,
				showConfirmButton: false,
				allowOutsideClick: false,
				allowEscapeKey: false,
				allowEnterKey: false,
				onBeforeOpen: () => {
					Swal.showLoading();
				},
			});
			const encodedParams = new URLSearchParams({
				startdate: startDate,
				enddate: endDate,
			}).toString();
			const response = await fetch(
				`${process.env.REACT_APP_PUBLIC_API_URL}/api/SDoc/SDoCSummaryExcel`,
				{
					method: 'POST',
					headers: {
						'Authorization': `Basic bmJ0YyNkYXRhY2VudGVyOmRhdGFjZW50ZXJzZG9jQDY1`,
						'Content-Type': 'application/x-www-form-urlencoded',
					},
					body: encodedParams,
				}
			);

			if (response.ok) {
				const blob = await response.blob();

				// Close the loading popup
				loadingPopup.close();

				// Create a download link
				const downloadLink = document.createElement('a');
				downloadLink.href = URL.createObjectURL(blob);
				downloadLink.download = 'SDoCSummary.xlsx';

				// Trigger a click event on the download link
				downloadLink.click();

				// Cleanup: Remove the download link
				URL.revokeObjectURL(downloadLink.href);
				downloadLink.remove();
			} else {
				// Close the loading popup
				loadingPopup.close();

				// Handle error response
				console.error('Download failed:', response.statusText);
			}
		} catch (error) {
			console.error('Download failed:', error);
		}
	};
	const handleDownloadSummaryFullClick = async () => {
		try {
			// Display a loading popup
			handleCloseDialogRangeDate();

			const loadingPopup = Swal.fire({
				title: 'กำลังดาวน์โหลดไฟล์',
				text: 'โปรดรอสักครู่...',
				icon: 'info',
				showCancelButton: false,
				showConfirmButton: false,
				allowOutsideClick: false,
				allowEscapeKey: false,
				allowEnterKey: false,
				onBeforeOpen: () => {
					Swal.showLoading();
				},
			});
			const encodedParams = new URLSearchParams({
				startdate: startDate,
				enddate: endDate,
			}).toString();
			const response = await fetch(
				`${process.env.REACT_APP_PUBLIC_API_URL}/api/SDoc/SDoCSummaryFull`,
				{
					method: 'POST',
					headers: {
						'Authorization': `Basic bmJ0YyNkYXRhY2VudGVyOmRhdGFjZW50ZXJzZG9jQDY1`,
						'Content-Type': 'application/x-www-form-urlencoded',
					},
					body: encodedParams,
				}
			);

			if (response.ok) {
				const blob = await response.blob();

				// Close the loading popup
				loadingPopup.close();

				// Create a download link
				const downloadLink = document.createElement('a');
				downloadLink.href = URL.createObjectURL(blob);
				downloadLink.download = 'SDoCAddress.xlsx';

				// Trigger a click event on the download link
				downloadLink.click();

				// Cleanup: Remove the download link
				URL.revokeObjectURL(downloadLink.href);
				downloadLink.remove();
			} else {
				// Close the loading popup
				loadingPopup.close();

				// Handle error response
				console.error('Download failed:', response.statusText);
			}
		} catch (error) {
			console.error('Download failed:', error);
		}
	};
	function exceljsPreProcess({ workbook, worksheet }) {
		workbook.created = new Date(); // Add metadata
		worksheet.name = 'Monthly Results'; // Modify worksheet name

		// Write on first line the date of creation
		worksheet.getCell('A1').value = `Values from the`;
		worksheet.getCell('A2').value = new Date();
	}

	function exceljsPostProcess({ worksheet }) {
		// Add a text after the data
		worksheet.addRow(); // Add empty row

		const newRow = worksheet.addRow();
		newRow.getCell(1).value = 'Those data are for internal use only';
	}


	const formatDate = (date) => {
		if (!(date instanceof Date) || isNaN(date)) {
			return ''; // or handle invalid dates appropriately
		}
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	};


	const [DialogRangeDateType, setDialogRangeDateType] = useState('SDoCSummaryExcel'); //  SDoCSummaryExcel or SDoCSummaryFull
	const [openDialogRangeDate, setOpenDialogRangeDate] = useState(false);
	const handleCloseDialogRangeDate = () => {
		setOpenDialogRangeDate(false);
	};
	const handleOpenDialogRangeDate = (sdoctype) => {
		setDialogRangeDateType(sdoctype);
		setOpenDialogRangeDate(true);
	};
	// initail value for startDate yesterday
	const [startDate, setStartDate] = useState(formatDate(new Date(new Date().setDate(new Date().getDate() - 1))));
	// initial value for endDate today
	const [endDate, setEndDate] = useState(formatDate(new Date()));
	const handleStartDateChange = (event) => {
		setStartDate(event.target.value);
	};

	const handleEndDateChange = (event) => {
		setEndDate(event.target.value);
	};

	// Export CSV dialog ("ดาวน์โหลดรายการที่อนุมัติแล้ว")
	const [openDialogExportCSV, setOpenDialogExportCSV] = useState(false);
	const [csvExportMode, setCsvExportMode] = useState('table'); // 'table' or 'range'
	const handleOpenDialogExportCSV = () => {
		setCsvExportMode('table');
		setOpenDialogExportCSV(true);
	};
	const handleCloseDialogExportCSV = () => {
		setOpenDialogExportCSV(false);
	};

	return (
		<>
			<Grid className="flex flex-col">
				<Grid className="p-10">
					<Card className={`border-t-4 border-card_top_border`}>
						<Grid className="flex flex-col justify-center items-start overflow-auto mb-5">
							<Grid className="flex flex-row items-center mt-4 mb-3 px-5">
								<Grid>
									<ListAlt style={{ fontSize: 22 }} className="mr-1" />
								</Grid>
								<Grid className="font-bold text-sm text-card_header_color">
									แบบรับรองตนเองทีได้รับการอนุมัติแล้ว
								</Grid>
							</Grid>
							<Grid className="flex flex-row items-center mt-4 mb-3 px-5 gap-x-2">
								<Button
									className={`w-36`}
									color="primary"
									variant="contained"
									onClick={toggleDialog}>
									<Search style={{ fontSize: 16 }} className="mr-1" />
									<Grid className={`text-xs`}>ค้นหาขั้นสูง</Grid>
								</Button>
								{myRole !== 18 && (
									<>
										<Button
											className={`w-72`}
											color="primary"
											variant="contained"
											onClick={handleOpenDialogExportCSV}>
											<Grid className={`text-xs`}>ดาวน์โหลดรายการที่อนุมัติแล้ว</Grid>
										</Button>
										<Button
											className={`w-72`}
											color="primary"
											variant="contained"
											style={{ height: '30px' }}
											onClick={() => handleOpenDialogRangeDate('SDoCSummaryExcel')}>
											<SaveAlt style={{ fontSize: 16 }} className="mr-1" />
											<Grid className={`text-xs`}>แบบรับรองตนเองทีได้รับการอนุมัติ</Grid>
										</Button>
										<Button
											className={`w-72`}
											color="primary"
											variant="contained"
											style={{ height: '30px' }}
											onClick={() => handleOpenDialogRangeDate('SDoCSummaryFull')}>
											<SaveAlt style={{ fontSize: 16 }} className="mr-1" />
											<Grid className={`text-xs`}>ข้อมูลผู้ยื่นแบบรับรองตนเองที่ได้รับการอนุมัติ</Grid>
										</Button>
									</>
								)}
							</Grid>
							{/* <Grid className="flex flex-row items-center mt-4 mb-3 px-5">
								<Button
									className={`w-72`}
									color="primary"
									variant="contained"
									onClick={handleDownloadClick}>
									<GetApp style={{ fontSize: 16 }} className="mr-1" />
									<Grid className={`text-xs`}>แบบรับรองตนเองทีได้รับการอนุมัติ</Grid>
								</Button>
							</Grid> */}
							<Grid className="md:px-5" style={{ height: '80vh', width: '100%', overflow: 'hidden' }}>
								<DataGrid
									rows={rowsApproveStatus}
									columns={columnsApproveStatus}
									loading={isDataLoading}
									initialState={{ columns: { columnVisibilityModel: { sDocNoExport: false, approveDateExport: false, invoiceDate: false, amount: false } } }}
									paginationMode="server"
									rowCount={totalRows}
									paginationModel={{ page: currentPage, pageSize }}
									onPaginationModelChange={(model) => {
										const pageSizeChanged = model.pageSize !== pageSize
										setPageSize(model.pageSize)
										setCurrentPage(pageSizeChanged ? 0 : model.page)
										getSDOCWaitStatusList(pageSizeChanged ? 0 : model.page, activeFilters, model.pageSize)
									}}
									pageSizeOptions={[5, 10, 25, 50]}
									disableRowSelectionOnClick
									sortingMode="server"
									filterMode="server"
									filterModel={gridFilterModel}
									onFilterModelChange={handleFilterChange}
									rowHeight={66}
									onSortModelChange={(model) => {
										handleSortChange(model)
									}}
									slots={{
										pagination: CustomPagination,
										noRowsOverlay: () => <GridOverlay>ไม่พบข้อมูล</GridOverlay>,
									}}
									slotProps={{
										loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' },
									}}
									sx={{ fontFamily: 'Sarabun, sans-serif', '& .MuiDataGrid-cell': { display: 'flex', alignItems: 'center' } }}
								/>
							</Grid>
						</Grid>
					</Card>
				</Grid>
			</Grid>

			<SelectSDocGroupTypeModal
				open={openModalSelectSDocGroupType}
				onClose={() => setOpenModalSelectSDocGroupType(false)}
				handleButton={onSetSDocGroupType}
				onChangeSDocGroupTypeID={onChangeSDocGroupTypeID}
				sDocGroupTypeList={sDocGroupTypeList}
				sDocGroupTypeID={sDocGroupTypeID}
			/>

			<Dialog
				className="w-full"
				fullScreen={isMobile}
				maxWidth="md"
				fullWidth
				scroll="paper"
				open={isDialogOpen}
				onClose={toggleDialog}>
				<DialogTitle style={{ backgroundColor: '#a74345' }}>
					<Grid
						container
						direction="row"
						justifyContent="space-between"
						alignItems="center">
						<Grid className="flex flex-row items-center" component="div">
							<Grid className="text-white">ค้นหาขั้นสูง</Grid>
						</Grid>
						<IconButton onClick={toggleDialog} style={{ color: '#fff' }}>
							<Close />
						</IconButton>
					</Grid>
				</DialogTitle>
				<DialogContent dividers>
					<div className="w-full" style={{ textAlign: 'left' }}>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>เลขที่ใบรับรอง:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'sDocNo')?.value || ''}
									placeholder="(ไม่ต้องใส่ SD นำหน้า)"
									id="sDocNo"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>เลขที่คำขอ:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'runningNumber')?.value || ''}
									placeholder="(ไม่ต้องใส่ SR นำหน้า)"
									id="runningNumber"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>ตราอักษร:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'brandName')?.value || ''}
									id="brandName"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>รุ่นของผลิตภัณฑ์:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'productModel')?.value || ''}
									id="productModel"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>ผู้ยื่นเอกสาร:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'operator')?.value || ''}
									id="operator"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>ยื่นในนาม:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'operatorInfo')?.value || ''}
									id="operatorInfo"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>ผู้ได้รับมอบหมายงาน:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'approver')?.value || ''}
									id="approver"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>วันที่ได้รับอนุมัติ:</div>
							<div className="flex-1">
								<TextField
									style={isMobile ? { width: '100%' } : { maxWidth: '200px', width: '200px' }}
									type="date"
									value={searchCreate}
									onChange={handleCreateChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>หมายเลขอ้างอิง 1:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'refNo1')?.value || ''}
									id="refNo1"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>หมายเลขอ้างอิง 2:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'refNo2')?.value || ''}
									id="refNo2"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>เลขที่ใบเสร็จรับเงิน:</div>
							<div className="flex-1">
								<TextField
									className="w-full"
									value={searchQuery.find(query => query.id === 'invoiceNo')?.value || ''}
									id="invoiceNo"
									onChange={handleSearchChange}
								/>
							</div>
						</div>
						<div className={isMobile ? "flex flex-col mb-3" : "flex flex-row items-center mb-2"}>
							<div style={isMobile ? {} : { width: '20%', flexShrink: 0 }}>บันทึกข้อมูลการค้นหา:</div>
							<div className="flex-1">
								<Switch
									checked={isSaveSearch}
									onChange={handleSaveSearch}
									color="primary"
								/>
							</div>
						</div>
					</div>
				</DialogContent>
				<DialogActions>
					<Grid
						className={isMobile ? "w-full px-2 flex flex-col gap-2" : "w-8/12 mx-auto flex flex-row justify-between items-center"}
						component="div">
						<Button
							className={isMobile ? "w-full" : "w-5/12"}
							onClick={onSearchResultClear}
							color="secondary"
							variant="outlined">
							ล้างผลการค้นหา
						</Button>
						<Button
							className={isMobile ? "w-full" : "w-5/12"}
							color="primary"
							variant="contained"
							onClick={onSearchResult}>
							ค้นหา
						</Button>
					</Grid>
				</DialogActions>
			</Dialog>

			<Dialog open={openDialogRangeDate} onClose={handleCloseDialogRangeDate} aria-labelledby="form-dialog-title">
				<DialogTitle style={{ backgroundColor: '#a74345' }}>
					<Grid
						container
						direction="row"
						justifyContent="space-between"
						alignItems="center">
						<Grid className="flex flex-row items-center" component="div">
							<Grid className="text-white">ดาวน์โหลดข้อมูล{DialogRangeDateType == "SDoCSummaryExcel" ? "แบบรับรองตนเองทีได้รับการอนุมัติ" : "ผู้ยื่นแบบรับรองตนเองที่ได้รับการอนุมัติ"}</Grid>
						</Grid>
						<IconButton onClick={handleCloseDialogRangeDate} style={{ color: '#fff' }}>
							<Close />
						</IconButton>
					</Grid>
				</DialogTitle>
				<DialogTitle id="form-dialog-title">เลือกวันที่เริ่มต้นและสิ้นสุด</DialogTitle>
				<DialogContent>
					<table>
						<tbody>
							<tr>
								<td>วันที่เริ่มต้น:</td>
								<td>
									<TextField
										style={{ maxWidth: '200px', width: '200px' }}
										type="date"
										value={startDate}
										onChange={handleStartDateChange}
									/>
								</td>
							</tr>
							<tr>
								<td>วันที่สิ้นสุด:</td>
								<td>
									<TextField
										style={{ maxWidth: '200px', width: '200px' }}
										type="date"
										value={endDate}
										onChange={handleEndDateChange}
									/>
								</td>
							</tr>
						</tbody>
					</table>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseDialogRangeDate} color="primary">
						ยกเลิก
					</Button>
					<Button onClick={DialogRangeDateType == "SDoCSummaryExcel" ? handleDownloadClick : handleDownloadSummaryFullClick} color="primary">
						ดาวน์โหลด
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog open={openDialogExportCSV} onClose={handleCloseDialogExportCSV} aria-labelledby="form-dialog-export-csv" fullWidth maxWidth="sm">
				<DialogTitle style={{ backgroundColor: '#a74345' }}>
					<Grid
						container
						direction="row"
						justifyContent="space-between"
						alignItems="center">
						<Grid className="flex flex-row items-center" component="div">
							<Grid className="text-white">ดาวน์โหลดรายการที่อนุมัติแล้ว</Grid>
						</Grid>
						<IconButton onClick={handleCloseDialogExportCSV} style={{ color: '#fff' }}>
							<Close />
						</IconButton>
					</Grid>
				</DialogTitle>
				<DialogContent>
					<RadioGroup
						value={csvExportMode}
						onChange={(event) => setCsvExportMode(event.target.value)}
						style={{ marginTop: '8px' }}>
						<FormControlLabel
							value="table"
							control={<Radio color="primary" />}
							label="ใช้ข้อมูลในตาราง"
						/>
						<FormControlLabel
							value="range"
							control={<Radio color="primary" />}
							label="ตามช่วงเวลาที่เลือก"
						/>
					</RadioGroup>
					{csvExportMode === 'range' && (
						<table>
							<tbody>
								<tr>
									<td>วันที่เริ่มต้น:</td>
									<td>
										<TextField
											style={{ maxWidth: '200px', width: '200px' }}
											type="date"
											value={startDate}
											onChange={handleStartDateChange}
										/>
									</td>
								</tr>
								<tr>
									<td>วันที่สิ้นสุด:</td>
									<td>
										<TextField
											style={{ maxWidth: '200px', width: '200px' }}
											type="date"
											value={endDate}
											onChange={handleEndDateChange}
										/>
									</td>
								</tr>
							</tbody>
						</table>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseDialogExportCSV} color="primary">
						ยกเลิก
					</Button>
					<Button onClick={() => handleExportCSV(csvExportMode)} color="primary">
						ดาวน์โหลด
					</Button>
				</DialogActions>
			</Dialog>
		</>
	)
}
